import { intervalToDuration } from 'date-fns'

export const rebateLevels = {
  mercedes: [
    {
      index: 0,
      maximumMonths: 3,
      maximumMileage: 4000,
      rebateRatio: 1,
    },
    {
      index: 1,
      maximumMonths: 6,
      maximumMileage: 8000,
      rebateRatio: 0.8,
    },
    {
      index: 2,
      maximumMonths: 9,
      maximumMileage: 12000,
      rebateRatio: 0.65,
    },
    {
      index: 3,
      maximumMonths: 12,
      maximumMileage: 16000,
      rebateRatio: 0.5,
    },
    {
      index: 4,
      rebateRatio: 0,
    },
  ],
  bmw: [
    {
      index: 0,
      maximumMileage: 8000,
      rebateRatio: 1,
    },
    {
      index: 1,
      maximumMileage: 16000,
      rebateRatio: 0.8,
    },
    {
      index: 2,
      maximumMileage: 24000,
      rebateRatio: 0.6,
    },
    {
      index: 3,
      maximumMileage: 32000,
      rebateRatio: 0.4,
    },
    {
      index: 4,
      maximumMileage: 40000,
      rebateRatio: 0.2,
    },
    {
      index: 5,
      rebateRatio: 0,
    },
  ],
  jlr: [
    {
      index: 0,
      maximumMonths: 3,
      maximumMileage: 5000,
      rebateRatio: 1,
    },
    {
      index: 1,
      maximumMonths: 6,
      maximumMileage: 10000,
      rebateRatio: 0.8,
    },
    {
      index: 2,
      maximumMonths: 9,
      maximumMileage: 15000,
      rebateRatio: 0.6,
    },
    {
      index: 3,
      maximumMonths: 12,
      maximumMileage: 20000,
      rebateRatio: 0.4,
    },
    {
      index: 4,
      maximumMonths: 18,
      maximumMileage: 25000,
      rebateRatio: 0.2,
    },
    {
      index: 5,
      maximumMonths: 24,
      maximumMileage: 30000,
      rebateRatio: 0.1,
    },
    {
      index: 6,
      rebateRatio: 0,
    },
  ],
  vw: [
    {
      index: 0,
      maximumMonths: 6,
      maximumMileage: 6000,
      rebateRatio: 1,
    },
    {
      index: 1,
      maximumMonths: 9,
      maximumMileage: 9000,
      rebateRatio: 0.75,
    },
    {
      index: 2,
      maximumMonths: 12,
      maximumMileage: 12000,
      rebateRatio: 0.5,
    },
    {
      index: 3,
      rebateRatio: 0,
    },
  ],
  byd: [
    {
      index: 0,
      maximumMonths: 12,
      maximumMileage: 4000,
      rebateRatio: 1,
    },
    {
      index: 1,
      maximumMonths: 12,
      maximumMileage: 8000,
      rebateRatio: 0.4,
    },
    {
      index: 2,
      maximumMonths: 12,
      maximumMileage: 12000,
      rebateRatio: 0.2,
    },
    {
      index: 3,
      rebateRatio: 0,
    },
  ],
  vwsg: [
    {
      index: 0,
      maximumMonths: 6,
      maximumMileage: 6000,
      rebateRatio: 1,
    },
    {
      index: 1,
      maximumMonths: 9,
      maximumMileage: 9000,
      rebateRatio: 0.75,
    },
    {
      index: 2,
      maximumMonths: 12,
      maximumMileage: 12000,
      rebateRatio: 0.5,
    },
    {
      index: 3,
      rebateRatio: 0,
    },
  ],
}

export const getRebateRatio = ({
  dealershipBrand,
  mileage = -1,
  dateOfPurchase,
  dateOfClaim = new Date(),
}) => {
  if (!dealershipBrand || isNaN(mileage) || mileage < 0) {
    return -1
  }
  if (!['bmw'].includes(dealershipBrand) && (!dateOfPurchase || dateOfClaim < dateOfPurchase)) {
    return -1
  }
  const {
    years = 0,
    months = 0,
    days = 0,
  } = intervalToDuration({ start: dateOfPurchase, end: dateOfClaim })
  const totalMonths = years * 12 + months + Math.min(days, 1)
  return rebateLevels[dealershipBrand].reduce(
    (previous, current) =>
      previous >= 0
        ? previous
        : (!current.maximumMileage || current.maximumMileage >= mileage) &&
          (!current.maximumMonths || current.maximumMonths >= totalMonths)
        ? current.rebateRatio
        : -1,
    -1
  )
}

export const getRebatePercentage = ({
  dateOfPurchase,
  createdAt,
  mileage,
  mileageOnPurchase,
  dealershipBrand,
}) => {
  const rebateRatio = getRebateRatio({
    dealershipBrand,
    mileage: Number(mileage - mileageOnPurchase),
    dateOfPurchase,
    dateOfClaim: createdAt,
  })
  if (rebateRatio < 0) {
    return 'Invalid'
  }
  return `${rebateRatio * 100 || 0}%`
}
